







import { createComponent, onMounted } from "@vue/composition-api";
import Base from "@/layouts/Base.vue"

// export default {
//   name: 'App',
// }

export default createComponent({
  components: {Base},
  setup() {
    onMounted(() => {
      if (process.env.VUE_APP_DEV_ENV !== "production") {
      }
    });
  }
});
